
  import React from "react"
  import Component from "M:/_AE/DaganMind - free template - harry potter/website/src/layouts/index.js"
  import data from "M:\\_AE\\DaganMind - free template - harry potter\\website\\.cache\\json\\layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js